import React from "react";

const SuccessModel = ({
  isOpen,
  title = "Alert!",
  message = "Something went wrong.",
  buttonText = "OK",
  messageClassName = "text-start",
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-backdrop">
      <div className="confirm-modal-container text-center px-4 py-3">
        {/* Success SVG */}
        <div className="mb-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#28a745"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M9 12l2 2l4-4" />
          </svg>
        </div>

        <h2 className="confirm-modal-title">{title}</h2>
        <p className={`confirm-modal-message ${messageClassName}`}>{message}</p>

        <div className="confirm-modal-buttons d-flex flex-column justify-content-center align-items-center gap-2 mt-3">
          <button
            autoFocus
            onClick={() => {
              onClose()
            }}
            // data-bs-dismiss="offcanvas"
            // aria-label="Close"
            className="confirm-modal-btn w-100 custom-success-btn"
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModel;
